import axios from "../../utils/axiosConfig";
import { AddBatchDTO, AddSupplierBatchDTO, BatchPaginationDTO, HideBatchDTO, RestockBatchDTO, ValidateBatchDTO } from "../../dtos/batch";

 
axios.defaults.withCredentials = true;


const getBatch = async (pharmacy_id: any,  dto?: BatchPaginationDTO) => {
  let url = `/api/pharmacy/batch/get?pharmacy_id=${pharmacy_id}`;

  // If dto exists, add optional parameters
  if (dto) {
    if (dto.page) url += `&page=${encodeURIComponent(dto.page)}`;
    if (dto.limit) url += `&limit=${encodeURIComponent(dto.limit)}`;
    if (dto.search) url += `&search=${encodeURIComponent(dto.search)}`;
    if (dto.date) url += `&date=${encodeURIComponent(dto.date)}`;
    if (dto.id) url += `&id=${encodeURIComponent(dto.id)}`;
    if (dto.added_by !== undefined) url += `&added_by=${dto.added_by}`;
    if (dto.updated_by !== undefined) url += `&updated_by=${dto.updated_by}`;
    if (dto.expire_med !== undefined) url += `&expire_med=${dto.expire_med}`;
    if (dto.near_expire !== undefined) url += `&near_expire=${dto.near_expire}`;
    if (dto.first_filter_call !== undefined) url += `&first_filter_call=${dto.first_filter_call}`;
  }
  
    const { data } = await axios.get(url);
  return data;
};

const AddBatch = async (batch: AddBatchDTO ) => {
  const { data } = await axios.post( "/api/pharmacy/batch/add", batch);
  return data;
};

const AddSupplierBatch = async (supplierBatch: AddSupplierBatchDTO ) => {
  const { data } = await axios.put( "/api/pharmacy/batch/update_supplier_batches", supplierBatch);
  return data;
};

const editBatch = async (batch: AddBatchDTO) => {
  const { data } = await axios.put( `/api/pharmacy/batch/update`, batch);
  return data;
};
const HideBatch = async (batch: HideBatchDTO ) => {
  const { data } = await axios.put( "/api/pharmacy/batch/change_batch_status", batch);

  return data;
};
const validateBatch = async (batch: ValidateBatchDTO) => {
  const url = `/api/pharmacy/batch/get_cost_price?pharmacy_id=${encodeURIComponent(
    batch.pharmacy_id
  )}&medicine_id=${encodeURIComponent(batch.medicine_id)}`;

  const { data } = await axios.get(url);

  return data;
};
const getAllMedBatch = async (batch: ValidateBatchDTO) => {
  const url = `/api/pharmacy/batch/get_med_all_batch?pharmacy_id=${encodeURIComponent(
    batch.pharmacy_id
  )}&medicine_id=${encodeURIComponent(batch.medicine_id)}`;

  const { data } = await axios.get(url);

  return data;
};

const restockBatch = async (batch: RestockBatchDTO) => {
  const { data } = await axios.put( `/api/pharmacy/batch/restock_batch`, batch);
  return data;
};

const BatchService = {
  getBatch,
  AddBatch,
  editBatch,
  HideBatch,
  validateBatch,
  getAllMedBatch,
  restockBatch,
  AddSupplierBatch
};

export default BatchService;